import { render, staticRenderFns } from "./JsonKeyValuePair.vue?vue&type=template&id=48be97c6&scoped=true"
import script from "./JsonKeyValuePair.vue?vue&type=script&lang=js"
export * from "./JsonKeyValuePair.vue?vue&type=script&lang=js"
import style0 from "./JsonKeyValuePair.vue?vue&type=style&index=0&id=48be97c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be97c6",
  null
  
)

export default component.exports